import { useEffect, useState } from 'react';
import { Table, Input, Select, Button, Tag, Modal, Form, message, Space, Popconfirm, Avatar } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import './admin.css';

const STATUS_MAP = {
  1: { t: 'Aktiv', c: 'green' }, 2: { t: 'Nofaol', c: 'orange' },
  3: { t: 'Bloklangan', c: 'red' }, 4: { t: "O'chirilgan", c: 'default' },
};
const ROLE_COLOR = { 1: 'red', 2: 'volcano', 3: 'purple', 4: 'blue', 7: 'orange' };

export default function AdminUsers() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [roleFilter, setRoleFilter] = useState(null);
  const [roles, setRoles] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form] = Form.useForm();

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (search) params.search = search;
      if (roleFilter) params.role = roleFilter;
      const r = await api.get('/admingov/users', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik yuz berdi'); }
    setLoading(false);
  };

  useEffect(() => {
    api.get('/admingov/roles').then(r => setRoles(r.data.data)).catch(() => {});
  }, []);
  useEffect(() => { setPage(1); fetchData(1); /* eslint-disable-next-line */ }, [search, roleFilter]);

  const handleEdit = (record) => {
    setEditUser(record);
    form.setFieldsValue({
      fullname: record.fullname, phone: record.phone,
      roles_id: record.roles_id, user_statusses_id: record.user_statusses_id,
    });
    setEditModal(true);
  };

  const handleSave = async () => {
    const vals = await form.validateFields();
    try {
      await api.put(`/admingov/users/${editUser.id}`, vals);
      message.success('Saqlandi'); setEditModal(false); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/users/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    {
      title: 'Foydalanuvchi', dataIndex: 'fullname',
      render: (name) => (
        <Space>
          <Avatar size={28} style={{ background: 'linear-gradient(135deg,#5F33E1,#8B5CF6)', fontSize: 13 }}>
            {(name || '?').charAt(0).toUpperCase()}
          </Avatar>
          <span style={{ fontWeight: 600 }}>{name || '—'}</span>
        </Space>
      ),
    },
    { title: 'Telefon', dataIndex: 'phone', render: v => v || '—' },
    { title: 'Rol', dataIndex: 'role_name', render: (t, r) => <Tag color={ROLE_COLOR[r.roles_id] || 'default'}>{t || '—'}</Tag> },
    {
      title: 'Status', dataIndex: 'user_statusses_id',
      render: (v) => { const s = STATUS_MAP[v]; return s ? <Tag color={s.c}>{s.t}</Tag> : <Tag>—</Tag>; },
    },
    { title: 'Yaratilgan', dataIndex: 'created', render: v => v ? new Date(v).toLocaleDateString('uz-UZ') : '—' },
    {
      title: 'Amallar', width: 100, fixed: 'right',
      render: (_, r) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(r)} />
          <Popconfirm title="O'chirishni tasdiqlaysizmi?" okText="Ha" cancelText="Yo'q" onConfirm={() => handleDelete(r.id)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="admin-toolbar">
        <Input placeholder="Ism yoki telefon bo'yicha qidirish" prefix={<SearchOutlined />} allowClear
          value={search} onChange={e => setSearch(e.target.value)} style={{ width: 280 }} />
        <Select placeholder="Rol bo'yicha" allowClear style={{ width: 200 }} value={roleFilter} onChange={setRoleFilter}
          options={roles.map(r => ({ label: r.name, value: r.id }))} />
        <span style={{ marginLeft: 'auto', color: 'var(--a-muted)', fontSize: 13 }}>Jami: <b>{total}</b></span>
      </div>

      <div className="admin-table-card">
        <Table dataSource={data} columns={columns} rowKey="id" loading={loading} size="middle" scroll={{ x: 760 }}
          pagination={{ current: page, total, pageSize: 20, showSizeChanger: false,
            onChange: p => { setPage(p); fetchData(p); } }} />
      </div>

      <Modal title="Foydalanuvchini tahrirlash" open={editModal} onOk={handleSave}
        onCancel={() => setEditModal(false)} okText="Saqlash" cancelText="Bekor">
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="fullname" label="Ism" rules={[{ required: true, message: 'Kiriting' }]}><Input /></Form.Item>
          <Form.Item name="phone" label="Telefon" rules={[{ required: true, message: 'Kiriting' }]}><Input /></Form.Item>
          <Form.Item name="roles_id" label="Rol">
            <Select options={roles.map(r => ({ label: r.name, value: r.id }))} />
          </Form.Item>
          <Form.Item name="user_statusses_id" label="Status">
            <Select options={[
              { label: 'Aktiv', value: 1 }, { label: 'Nofaol', value: 2 },
              { label: 'Bloklangan', value: 3 }, { label: "O'chirilgan", value: 4 },
            ]} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
